import { render } from "./GuardianPanel.vue?vue&type=template&id=256c7202&scoped=true"
import script from "./GuardianPanel.vue?vue&type=script&lang=js"
export * from "./GuardianPanel.vue?vue&type=script&lang=js"

import "./GuardianPanel.vue?vue&type=style&index=0&id=256c7202&scoped=true&lang=css"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256c7202"]])

export default __exports__